// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "sitesurvey",
            "endpoint": "https://u3gqkxx62h.execute-api.us-west-2.amazonaws.com/sitesurvey",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
